import { render } from "./AgentsAssignedToLeads.vue?vue&type=template&id=66a7355c&scoped=true"
import script from "./AgentsAssignedToLeads.vue?vue&type=script&lang=js"
export * from "./AgentsAssignedToLeads.vue?vue&type=script&lang=js"

import "./AgentsAssignedToLeads.vue?vue&type=style&index=0&id=66a7355c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a7355c"]])

export default __exports__